module.exports = __webpack_public_path__ + "static/media/CRV.f9de3ec6.svg";